export const CAPITAL_STACK_EVENTS = {
  CAPITAL_STACK_LAYER_ADDED: "CAPITAL_STACK_LAYER_ADDED",
  CAPITAL_STACK_LAYER_REMOVED: "CAPITAL_STACK_LAYER_REMOVED",
  CAPITAL_STACK_LAYER_UPDATED: "CAPITAL_STACK_LAYER_UPDATED",
  CAPITAL_STACK_LAYER_ORDER_UPDATED: "CAPITAL_STACK_LAYER_ORDER_UPDATED",
};
